var _path, _path2, _path3, _path4, _path5, _rect, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoodbyeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 126,
    viewBox: "0 0 138 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.888 25.8208C71.2143 22.9681 74.7328 21.2012 78.5136 21.1609H78.6457C85.5855 21.1609 91.2319 26.8073 91.2319 33.747C91.2319 41.6638 86.0466 48.4527 80.6436 53.3666C75.2562 58.2663 69.7527 61.2099 69.3167 61.4392L69.3164 61.4394C69.0607 61.5741 68.7806 61.6412 68.5008 61.6412C68.2209 61.6412 67.9407 61.5741 67.6854 61.4397C67.2487 61.2099 61.745 58.2666 56.3574 53.367C50.9542 48.4533 45.769 41.6642 45.769 33.7463C45.769 26.8069 51.4154 21.1602 58.3551 21.1602C62.1864 21.1602 65.7605 22.9354 68.113 25.8207L68.5004 26.296L68.888 25.8208Z",
    fill: "black",
    stroke: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4964 87.1045C83.9692 71.1998 95.793 70.1215 95.793 70.1215",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3797 66.9921C90.7334 62.4917 94.285 64.2441 94.285 64.2441",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9993 75.0794C54.1998 76.1292 55.1133 83.6929 55.1133 83.6929",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0745 108.668C33.5286 111.467 107.406 111.799 110.925 109.768C114.445 107.737 109.966 106.63 113.234 105.396C116.502 104.163 133.986 105.453 130.021 102.873C126.056 100.293 60.1843 103.024 56.7077 101.876C53.2311 100.728 60.2217 100.273 56.7526 98.5747C53.2835 96.8765 5.1222 94.5703 5.06234 98.9722C5.00249 103.374 39.9407 102.199 42.0057 104.428C44.0707 106.657 26.6203 105.87 30.0745 108.668Z",
    fill: "#F1F3F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 107,
    width: 5,
    height: 3,
    rx: 1.5,
    fill: "#F1F3F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4785 22.5007L72.5008 31.0007L64.5 41.0006L72.5 51.0006L67.4785 63.5006",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodbyeImg);
export default __webpack_public_path__ + "static/media/goodbye-img.38440f7e49b9720f684dd0485996959b.svg";
export { ForwardRef as ReactComponent };